import { render } from "./SettingsModule.vue?vue&type=template&id=a667e9ba&scoped=true"
import script from "./SettingsModule.vue?vue&type=script&lang=js"
export * from "./SettingsModule.vue?vue&type=script&lang=js"

import "./SettingsModule.vue?vue&type=style&index=0&id=a667e9ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a667e9ba"]])

export default __exports__